import { brandMapper } from "@/mappers/brand";
import { PluginObject } from "vue";

export const MapperPlugin: PluginObject<void> = {
  install(Vue) {
    Vue.prototype.$brandMapper = brandMapper;
  },
};
